// Module
var code = " <div class=\"row\"> <div class=\"col-lg-8\"> <h1>Admin Dashboard</h1> </div> </div> <div class=\"row\"> <div class=\"col-12 text-left\"> </div> </div> ";
// Exports
module.exports = code;